import classNames from 'classnames';
import {
  getISOWeek,
  isFriday,
  isSaturday,
  isSunday,
  isToday,
  isWeekend,
  isYesterday
} from 'date-fns';
import i18n from 'i18next';

import { Holidays } from '../../../redux/types';
import { RosterDay } from './types';
import { Interval } from 'components/types';

import { formatByLocale } from 'utils/date';

type CellDateClassesProps = {
  date: Date;
  isHoliday?: boolean;
  view?: 'day' | 'week' | 'month';
};

export const getCellDateClasses = (
  { date, isHoliday, view }: CellDateClassesProps,
  otherClasses: string[] = []
) =>
  classNames(
    {
      'is-yesterday': isYesterday(date),
      'is-today': isToday(date),
      'is-friday': isFriday(date),
      'is-saturday': isSaturday(date),
      'is-sunday': isSunday(date),
      'is-weekend': isWeekend(date),
      'is-holiday': isHoliday,
      'is-day-view': view === 'day',
      'is-week-view': view === 'week',
      'is-month-view': view === 'month'
    },
    ...otherClasses
  );

export const getRosterDays = (interval: Interval, holidays: Holidays) => {
  const days: RosterDay[] = [];
  const { startDate, endDate } = interval;
  const currentDate = new Date(startDate);
  while (currentDate < endDate) {
    const holiday = holidays[formatByLocale(currentDate, 'yyyy-MM-dd')];
    const isHoliday = Boolean(holiday);
    days.push({
      date: new Date(currentDate),
      day: currentDate.getDate(),
      dayName: formatByLocale(currentDate, 'EEEEEE'),
      dayNr: currentDate.getDay(),
      weekNr: getISOWeek(currentDate),
      isHoliday,
      isToday: isToday(currentDate),
      description: isHoliday ? holiday.description : i18n.t('today') || ''
    });
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return days;
};

export const prepareRosterForPrint = (content: HTMLDivElement) => {
  const contentClone = content.cloneNode(true) as HTMLElement;
  contentClone.classList.add('printed-roster');
  const rosterBody = contentClone.querySelector('.roster-body');
  if (rosterBody) {
    const osContent = rosterBody.querySelector('.os-content');
    if (osContent) {
      rosterBody.innerHTML = '';
      rosterBody.appendChild(osContent);
    }
  }
  Array.from(
    contentClone.querySelectorAll(`
                .print-roster-btn,
                .date-interval .prev-btn,
                .date-interval .next-btn,
                .arrow-navigation,
                .MuiAccordionSummary-expandIconWrapper,
                .planunit-selector .MuiButtonBase-root,
                .date-picker
            `)
  ).forEach((elem) => elem.remove());
  contentClone.querySelector('.filters')?.classList.add('v-hidden');
  return contentClone;
};
